module.exports = __webpack_public_path__ + "static/media/Inter-Black.02220bb6.woff2";